<template>
    <PopoverRoot v-bind="forwarded">
        <slot />
    </PopoverRoot>
</template>

<script setup lang="ts">
/** Originally imported via shadcn-vue. See https://ui.shadcn.com/docs/components/popover for further documentation.*/
import type { DsPopoverEmits, DsPopoverProps } from '@/components/design-system/popover/ds-popover.types';
import { PopoverRoot, useForwardPropsEmits } from 'reka-ui';

const props = defineProps<DsPopoverProps>();
const emits = defineEmits<DsPopoverEmits>();

const forwarded = useForwardPropsEmits(props, emits);
</script>
